export default "__VITE_ASSET__CEcOVv5e__"